import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'

type Props = {
  tagName: string
}

const TimeSaleTag: FC<Props> = (props) => {
  const { tagName } = props
  const baseStyle = styles.tag_time_sale

  return <span className={baseStyle}>{tagName}</span>
}

export default TimeSaleTag
